module.exports = __webpack_public_path__ + "img/noData.1b396a27.png";